// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportPopover-root-vYbHg","close":"ReportPopover-close-3Y-C1"};